export * from './available-currency.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/available-currency/index.ts